import { Lightning } from '@lightningjs/sdk';
import { SELECTED_SIGNAL } from '../../../tornado/signals';
import { TopBarItem } from './components/topBarItem.component';
import { defaultContext, GAP } from './topBar.style';
import { HEIGHT } from './components/topBarItem.style';

/**
 * The Barillet is on TopBar to control playback.
 *
 * @version 1.3.1
 * @see https://zeroheight.com/726d5c282/v/0/p/511a29-barillet
 */
export class TopBar extends Lightning.Component {
  static _template() {
    return {
      Items: {},
    };
  }

  _construct() {
    this._style = defaultContext;
    this._index = 0;
    this._items = [];
  }

  set items(value) {
    this._items = value;
    this._maxIndex = Math.max(this._items.length - 1, 0);

    const topBarItemHeight = HEIGHT[this._style.screenSize];
    const container = this.tag('Items');

    if (container.children.length === this._items.length) {
      container.children.forEach((view, index) => {
        view.data = this._items[index];
      });

      return;
    }

    container.children = this._items.map((data, index) => ({
      type: TopBarItem,
      data,
      y: (topBarItemHeight + GAP[this._style.screenSize]) * index,
    }));

    this._index = this._maxIndex;
    this._refocus();
  }

  get maxIndex() {
    return this._maxIndex;
  }

  get index() {
    return this._index;
  }

  set index(value) {
    this._index = value;
  }

  _getFocused() {
    return this.tag('Items').children[this._index];
  }

  _handleEnter() {
    const item = this._items[this._index];
    if (item) {
      this.signal(SELECTED_SIGNAL, item);

      return true;
    }

    return false;
  }

  _handleUp() {
    if (this.index > 0) {
      this.index -= 1;

      return true;
    }

    return false;
  }

  _handleDown() {
    if (this.index < this._maxIndex) {
      this.index += 1;

      return true;
    }

    return false;
  }
}
